export function Amap() {
	return new Promise(function (resolve, reject) {
		window.initMap = function () {
			resolve(AMap);
		}
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.src = "//webapi.amap.com/maps?v=1.4.1&key=ecdc840defcf2617b02dd0c7be1c38ae&callback=initMap";
		script.onerror = reject;
		document.head.appendChild(script);
	})
}


// WEBPACK FOOTER //
// ./src/config/AMap.js